














































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import {taskStatusZh} from "@/model/Task";
import deviceModule from "@/store/module/DeviceModule";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import DeviceTaskApi from "@/module/device/DeviceTaskApi";
import {DtaskPqForm} from '@/form/DeviceTaskForm';
import DeviceTask from "@/model/DeviceTask";

@Component({
  components: {
    PaginationTable,
    RefreshButton,
  },
})
export default class DeviceTaskView extends Vue {

  private dtaskApi = Container.get(DeviceTaskApi)

  @Ref()
  private ptable!: PaginationTable

  private get device() {
    return deviceModule.active
  }

  private paging = new Paging<DeviceTask>()
  private pqForm = new DtaskPqForm(
      this.device.id
  )

  private async getPaging() {
    return this.dtaskApi.paging(this.pqForm)
  }

  private taskStatusZh = taskStatusZh

  private statusFmt(task: DeviceTask) {
    return this.taskStatusZh[task.status]
  }
}
